module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/header-image-03-dbf89168e23d1657dae574bcffe5f6cc.jpg";